import { useContext } from "react";
import MyContext from "../context/permissions";

function usePermissionStatus(checkPermission=""){
    const {permissions} = useContext(MyContext);
    const admin_type=localStorage.getItem("admin_type");
    let availablePermission=[];
    let permit=false
    
    let filtered = permissions?.filter(item=>item.checked)
    if(admin_type==="sub_admin"){
        let available = filtered?.flatMap(item=>item.permission_name)?.includes(checkPermission);
        permit= available ? filtered?.find(item=>checkPermission=== item.permission_name)?.write:false;
    }
    else{
        permit= true
    }
    return permit;
}
export default usePermissionStatus;